var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "panel margin--bottom" },
    [
      _c(
        "bar-card",
        { attrs: { bg: "border3" } },
        [
          _c("v-title", [_vm._v("品牌产品")]),
          _c("div", { staticClass: "content" }, [
            _vm.list.length > 0
              ? _c(
                  "div",
                  { staticClass: "tops flex", attrs: { id: "imageList" } },
                  [
                    _c(
                      "swiper",
                      {
                        ref: "mySwipers",
                        staticClass: "imgcasesT",
                        attrs: { options: _vm.swiperOption },
                      },
                      _vm._l(_vm.list, function (it, index) {
                        return _c(
                          "swiper-slide",
                          { key: index, staticClass: "swiper-slides" },
                          [
                            _c("div", { staticClass: "cubeBox flex" }, [
                              _c("div", { staticClass: "topTitle" }, [
                                _c("div", { staticClass: "xcTop flex" }, [
                                  _c(
                                    "span",
                                    { staticStyle: { "margin-left": "13px" } },
                                    [_vm._v(_vm._s(it.name))]
                                  ),
                                ]),
                              ]),
                              _c("div", { staticClass: "imgBox" }, [
                                _c("div", { staticClass: "botTitle" }, [
                                  _c("div", { staticClass: "img" }, [
                                    _c("img", {
                                      staticClass: "imggs",
                                      attrs: { src: it.logo },
                                      on: {
                                        click: function ($event) {
                                          return _vm.previewClick(index)
                                        },
                                      },
                                    }),
                                  ]),
                                ]),
                              ]),
                              _c("div", { staticClass: "qrCode" }, [
                                _c("div", { staticClass: "botTitle qrBox" }, [
                                  _c(
                                    "div",
                                    { staticClass: "right_main flex" },
                                    [
                                      _c("div", { staticClass: "q_nav flex" }, [
                                        _c("div", { staticClass: "imgBoxs" }, [
                                          _c("img", {
                                            staticClass: "arround",
                                            attrs: {
                                              src: require("images/index/home/pp_cplx.png"),
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "div",
                                          { staticClass: "wz_div flex" },
                                          [
                                            _c("div", [_vm._v("产品类型")]),
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  color: "#00D2E4",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " + _vm._s(it.type) + " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]),
                                      _c("div", { staticClass: "q_nav flex" }, [
                                        _c("div", { staticClass: "imgBoxs" }, [
                                          _c("img", {
                                            staticClass: "arround",
                                            attrs: {
                                              src: require("images/index/home/ico_scqy.png"),
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "div",
                                          { staticClass: "wz_div flex" },
                                          [
                                            _c("div", [_vm._v("种植面积")]),
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  color: "#00D2E4",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(it.zzmj) + "(万亩)"
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]),
                                      _c("div", { staticClass: "q_nav flex" }, [
                                        _c("div", { staticClass: "imgBoxs" }, [
                                          _c("img", {
                                            staticClass: "arround",
                                            attrs: {
                                              src: require("images/index/home/pp_cpts.png"),
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "div",
                                          { staticClass: "wz_div flex" },
                                          [
                                            _c("div", [_vm._v("产量")]),
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  color: "#00D2E4",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(it.zzsl) + "(万吨)"
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]),
                              ]),
                            ]),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _c("div", {
              staticClass: "swiper-button-prev",
              on: {
                click: function ($event) {
                  return _vm.prevs()
                },
              },
            }),
            _c("div", {
              staticClass: "swiper-button-next",
              on: {
                click: function ($event) {
                  return _vm.nexts()
                },
              },
            }),
          ]),
        ],
        1
      ),
      _c("image-preview", {
        attrs: {
          show: _vm.imgpre,
          list: _vm.imglist,
          initialIndex: _vm.initialIndex,
        },
        on: {
          "update:show": function ($event) {
            _vm.imgpre = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }